import axios from 'axios';
import { apiEndpoint } from '@app/utils/constants';

/**
 * Dedicated axios instance for the public, unauthenticated Webchat page.
 * No auth-token injection and no refresh-token interceptor - this page has
 * no login session to attach. See docs/adr/0002-webchat-isolated-api-client.md.
 */
const webchatApi = axios.create({
    baseURL: apiEndpoint,
    headers: {
        'Content-type': 'application/json',
    },
});

export default webchatApi;
